import { useState, type FormEvent } from "react";
import { Button } from "@/ui/Button";
import { BoxInput, ErrorNote } from "@/ui/Field";
import { Screen } from "@/ui/Screen";
import { Display, Tiny } from "@/ui/Text";

interface EmailEntryProps {
  readonly initialEmail?: string;
  readonly onSubmit: (email: string) => void;
  readonly error: string | null;
  readonly busy?: boolean;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** The field and its button together, centred, so the keyboard never hides the action. */
export function EmailEntry({ initialEmail = "", onSubmit, error, busy = false }: EmailEntryProps) {
  const [email, setEmail] = useState(initialEmail);
  const valid = EMAIL_PATTERN.test(email.trim());

  function submit(event: FormEvent) {
    event.preventDefault();
    if (valid) onSubmit(email.trim());
  }

  return (
    <form onSubmit={submit} className="contents">
      <Screen middle>
        <Display>What’s your email?</Display>
        <div className="mt-8">
          <BoxInput
            label="Email"
            type="email"
            name="email"
            autoComplete="email"
            inputMode="email"
            autoCapitalize="none"
            autoCorrect="off"
            autoFocus
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <Tiny className="mt-2">We’ll email you a six-digit code. No password to remember.</Tiny>
        <ErrorNote message={error} />
        <div className="mt-6">
          <Button type="submit" label="Send my code" disabled={!valid} busy={busy} />
        </div>
      </Screen>
    </form>
  );
}
